export const PAYMENTS_OPS_PAGE_SIZE_OPTIONS = [20, 50, 100]

export const PAYMENTS_OPS_DEFAULT_PAGE_SIZE = 20

/** Retool's rule for authorization notes (trimmed). The backend only requires non-empty. */
export const AUTHORIZE_NOTES_MIN_LENGTH = 10

/** The captured-events list cannot be paginated (`limit`/`page` 400) — the backend caps it here. */
export const CAPTURED_EVENTS_PAGE_CAP = 50

/**
 * Rows asked of the bank-onboardings list (latest onboarding per partner, so one row per partner).
 * The server default of 100 silently dropped partners past it from partner blocking and from
 * "Start new from". The internal route parses `limit` and sets no maximum.
 */
export const BANK_ONBOARDINGS_FETCH_LIMIT = 1000

/** What the onboarding list puts in place of every SSN/EIN/DOB value. */
export const MASKED_VALUE = '******'

/**
 * Shown in place of a form whose partner picker needs `GET /partners` (`partners_view`), which
 * `PaymentsOpsLayout` skips without it — permission gating spec §6, §10.2.
 */
export const PARTNERS_REQUIRED_MESSAGE = 'Requires access to partners.'
